module.exports = __webpack_public_path__ + "static/media/MTL_SL_STRG1.e5102cc9.png";